// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"4674e5fe","801":"0c579513"}[chunkId] + ".chunk.js";
};